import axiosInstance from "./instance";

const toProductFormData = (product) => {
    const formData = new FormData();

    Object.entries(product || {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            return;
        }

        if (key === 'image' && value instanceof File) {
            formData.append(key, value, value.name);
            return;
        }

        if (key === 'searchKeywords' && Array.isArray(value)) {
            formData.append(key, JSON.stringify(value));
            return;
        }

        if (Array.isArray(value) || (typeof value === 'object' && !(value instanceof Blob))) {
            formData.append(key, JSON.stringify(value));
            return;
        }

        formData.append(key, value);
    });

    return formData;
};

// Get All Product by Status
const fetchProducts = async (page, status, limit = 15) => {
    const response = await axiosInstance.get('/products', {
        params: {
            page,
            limit,
            status
        }
    });
    return response.data;
}

// Get Solo Product Details
const fetchProduct = async (productId) => {
    const response = await axiosInstance.get(`/products/${productId}`);
    return response.data;
}

// Create Product
const addProduct = async (product) => {
    const response = await axiosInstance.post('/products', toProductFormData(product));
    return response.data;
}

// Update Product Details
const updateProductDetails = async (productId, product) => {
    const response = await axiosInstance.patch(`/products/${productId}/details`, toProductFormData(product));
    return response.data;
}

// Update Product Status
const updateProductStatus = async (productId, status) => {
    const response = await axiosInstance.patch(`/products/${productId}/status`, {
        status
    });
    return response.data;
}

// Delete Product
const deleteProduct = async (productId) => {
    const response = await axiosInstance.delete(`/products/${productId}`);
    return response.data;
}

// Backward-compatible alias for existing callers.
const updateProduct = updateProductStatus;

export {
    fetchProducts,
    fetchProduct,
    addProduct,
    updateProductDetails,
    updateProductStatus,
    deleteProduct,
    updateProduct
};
